// extracted by mini-css-extract-plugin
module.exports = {"Heading":"PlanDetail_Heading__10f1S","Subheading":"PlanDetail_Subheading__qhLP3","Benefit":"PlanDetail_Benefit__3-4Ra"};